module.exports = __webpack_public_path__ + "static/media/photo78.0490e0bb.jpg";